import { OptionsViewModel } from '@models/common.models';
export interface AuthorizationPromptViewModel {
  readonly promptId: number;
  readonly options: Array<OptionsViewModel>;
  readonly type: string;
  readonly required: boolean;
  readonly description: string;
  readonly maxLength?: number;
  readonly requiredIfReplace?: boolean;
  readonly order: number;
  readonly notCovered?: boolean;
  readonly isInternal?: boolean;
  readonly childPrompts?: Array<AuthorizationPromptViewModel>;
  readonly parentUUID?: string;
  readonly uuid: string;
  readonly isEstimate?: boolean;
  readonly updatesField: string;
  readonly defaultPayee: number;
  readonly canGrow: boolean;
}

export interface AuthorizationPromptAnswerViewModel {
  readonly promptUUID: string;
  readonly responseId?: number;
  readonly response: string;
  readonly isEstimate?: boolean;
  readonly notCovered?: boolean;
  readonly payeeType?: string;
  readonly promptType?: string;
  readonly responseChanged?: boolean;
  readonly previousResponse?: string;
}

export interface AuthorizationPromptResponseViewModel {
  readonly response: string;
  readonly responseId?: number;
  readonly promptId: number;
  readonly cviCode: number;
  readonly notCovered: boolean;
  readonly qOrder: number;
  readonly payeeType: string;
  readonly isEstimate: boolean;
  readonly updatesField: string;
  readonly subId?: number;
  readonly responseChanged?: boolean;
  readonly previousResponse?: string;
}

export interface AuthoVersionViewModel {
  readonly reportId: number;
  readonly versionNumber: number;
  readonly addNewDate: Date;
  readonly addNewEmployee: OptionsViewModel;
  readonly swoDetailNumber: number;
}

export enum AuthorizationPromptTypes {
  Text = 'Text',
  TextArea = 'TextArea',
  Number = 'Number',
  Price = 'Price',
  List = 'List',
  Date = 'DT',
  YesNo = 'YN',
  Multi = 'Multi'
}



// WEBPACK FOOTER //
// ./src/_models/AuthorizationPrompt.ts